"use strict";exports.getNumberRegex=e=>e?new RegExp(".*\\d{".concat(e,",}")):void 0;
